import { LANGUAGE_KEYS } from 'src/core/provider/AppMeta';

type TRANSLATION_FEEDBACK = `TRANSLATION_${Uppercase<Exclude<typeof LANGUAGE_KEYS[number], 'de'>>}`;

type VideoRatingFeedbackType = 'CONTENT' | 'MOTIVATION' | 'UNDERSTANDABILITY' | TRANSLATION_FEEDBACK;

export default class VideoRating {
    feedbackType: VideoRatingFeedbackType;
    localizedFeedbackType: string;
    rating: number;

    constructor(json: any) {
        this.feedbackType = json.feedbackType;
        this.localizedFeedbackType = json.localizedFeedbackType;
        this.rating = json.rating ?? 0;
    }
}
